import { useCallback, useRef } from 'react'

import { type AuthorPreview } from '@/entities/authors'
import { ROUTES } from '@/shared/config'
import { ContentWrapper, HeaderContent } from '@/shared/ui'
import { AlbumCollectionForm } from '@/widgets/AlbumCollectionForm'
import { AuthorForm, authorFormModalOpened } from '@/widgets/AuthorForm'
import { Breadcrumb, Layout } from 'antd'
import { useUnit } from 'effector-react'
import { Link, useLocation } from 'react-router-dom'

import { AlbumCollectionCreatePageGate } from './model/album-collection-create.model'

export const AlbumCollectionCreatePage = () => {
  const location = useLocation()
  const state = location.state as {
    author?: AuthorPreview
  }
  const author = state?.author

  const openAuthorsFormModal = useUnit(authorFormModalOpened)

  const onAuthorSubmitted = useRef<(id: string) => void>(() => {})
  const onAuthorButtonClick = useCallback(
    (callback: (id: string) => void) => {
      onAuthorSubmitted.current = callback
      openAuthorsFormModal()
    },
    [openAuthorsFormModal],
  )

  return (
    <Layout>
      <AlbumCollectionCreatePageGate />
      <AuthorForm
        isModal
        onSubmitted={(authorId: string) => onAuthorSubmitted.current(authorId)}
      />
      <HeaderContent
        breadcrumbSlot={
          <Breadcrumb
            items={[
              ...(author
                ? [
                    { title: 'Авторы' },
                    {
                      title: (
                        <Link
                          to={ROUTES.AUTHORS.EDIT.replace(':id', author.id)}
                        >
                          {author.nickname}
                        </Link>
                      ),
                    },
                  ]
                : [
                    { title: 'Контент' },
                    { title: 'Коллекции' },
                    {
                      title: (
                        <Link to={ROUTES.COLLECTIONS.ALBUM_COLLECTIONS}>
                          Выпуски
                        </Link>
                      ),
                    },
                  ]),
              {
                title: 'Создание выпуска',
              },
            ]}
          />
        }
        title="Создание выпуска"
        description="Раздел предоставляет возможность добавлять новый контент в каталог и управлять его параметрами"
      />

      <ContentWrapper>
        <AlbumCollectionForm onAuthorButtonClick={onAuthorButtonClick} />
      </ContentWrapper>
    </Layout>
  )
}
